import type { TreeProps } from 'ant-design-vue'

export default function addBackgroundClass() {
  const isExpandAddClass = (id:string[], data:TreeProps['treeData']) => {
    id.forEach(keyitem => {
      data?.forEach(dataItem => {
        if (dataItem.id === keyitem) {
          dataItem.class = 'isExpendBg'
          const childrenAddClass = (cData:TreeProps['treeData']) => {
            cData?.forEach((childrenItem) => {
              childrenItem.class = 'isExpendBg'
              if (childrenItem.children && childrenItem.children.length > 0) {
                childrenAddClass(childrenItem.children)
              }
            })
          }
          if (dataItem.children && dataItem.children.length > 0) {
            childrenAddClass(dataItem.children)
          }
        }
      })
    })
  }
  const removeExpandClass = (id:string[], data:TreeProps['treeData']) => {
    data?.forEach(item => {
      const index = id.find((keyItem) => {
        return keyItem === item.id
      })
      if (!index) {
        item.class = ''
        const childrenAddClass = (cData:TreeProps['treeData']) => {
          cData?.forEach((childrenItem) => {
            childrenItem.class = ''
            if (childrenItem.children && childrenItem.children.length > 0) {
              childrenAddClass(childrenItem.children)
            }
          })
        }
        if (item.children && item.children.length > 0) {
          childrenAddClass(item.children)
        }
      }
    })
  }
  return { isExpandAddClass, removeExpandClass }
}
